
const validate = values => {
  const errors = {}
  if (values.password!= values.password_confirmation) {
    errors.password_confirmation = 'Password does not match'
  }
  if (values.password && !values.verify_password) {
    errors.verify_password = 'Required for password update'
  }
  if (values.verify_password && !values.password) errors.password = 'Required'

  return errors
}

export default validate



// WEBPACK FOOTER //
// ./src/account/profile/validate.js